<template>
    <div 
        class="d-flex flex-column cardWrapper mb-16"
        :style="posicaoCard === 'esquerda' ? 'margin-left: 64px; justify-self: flex-start' 
                : posicaoCard === 'centro' ? 'justify-self: center'
                : posicaoCard === 'direita' ? 'margin-right: 64px; justify-self: flex-end' 
                : 'margin-left: 64px; justify-self: flex-start' "
    >
        <!-- Green triangle + Blue parallelogram (name) -->
        <div class="tarja-row tarja-row--top">
            <div class="green-triangle"></div>
            <div class="blue-parallelogram">
                <span class="blue-parallelogram__text">
                    {{ colabData?.dsc_nome_colaborador }}
                </span>
            </div>
        </div>

        <!-- White parallelogram (collaboration text) -->
        <div class="tarja-row tarja-row--bottom">
            <div class="white-parallelogram">
                <span class="white-parallelogram__text">
                    {{ colabData.dsc_texto_colaboracao }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        colabData: Object,
        posicaoCard: String
    }
}
</script>

<style lang="scss" scoped>
.cardWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: max-content;
    max-width: 100%;
}

.tarja-row {
    display: flex;
    align-items: stretch;
    position: relative;
    max-width: 100%;
}

/* ── Green triangle ── */
.green-triangle {
    position: absolute;
    bottom: 0;
    left: 0; 
    width: 90px; /* Dx + Sb = 60 + 30 */
    height: 70px; /* Sobe até a metade da altura da azul */
    background-color: #009B3A;
    clip-path: polygon(0 100%, 50px 0, 100% 100%);
    z-index: 0;
}

/* ── Blue parallelogram (top row) ── */
.blue-parallelogram {
    background: #2B0BD4;
    padding: 20px 48px 20px 55px;
    display: flex;
    align-items: center;
    clip-path: polygon(0 0, calc(100% - 20px) 0, 100% 100%, 20px 100%);
    min-height: 50px;
    flex: 1;
    z-index: 1;
    min-width: 0;
    margin-left: 20px; /* Define o início da azul bem depois da branca */
}

.blue-parallelogram__text {
    color: #FFFFFF;
    font-weight: 700;
    font-size: 1.6rem;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ── White parallelogram (bottom row) ── */
.tarja-row--bottom {
    margin-left: 0; 
    margin-right: 0; 
}

.white-parallelogram {
    background: #FFFFFF;
    padding: 20px 48px 20px 80px; /* padding-left ajustado para alinhar o texto com o da azul */
    display: flex;
    align-items: center;
    clip-path: polygon(0 0, calc(100% - 20px) 0, 100% 100%, 20px 100%);
    min-height: 44px;
    flex: 1;
    min-width: 0;
}

.white-parallelogram__text {
    color: #0066CC;
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 1.2;
    max-width: 70dvh;
    word-wrap: break-word;
}

/* ── Responsive: small-medium ── */
@media screen and (min-width: 576px) and (max-width: 767.98px) {
    .green-triangle {
        left: 0;
        width: 72px;
        height: 20px;
        clip-path: polygon(0 100%, 60px 0, 100% 100%);
    }

    .blue-parallelogram {
        min-height: 40px;
        padding: 6px 40px 6px 24px;
        clip-path: polygon(0 0, calc(100% - 24px) 0, 100% 100%, 24px 100%);
        margin-left: 48px;
    }

    .blue-parallelogram__text {
        font-size: 1.1rem;
    }

    .tarja-row--bottom {
        margin-left: 0;
        margin-right: 0;
    }

    .white-parallelogram {
        min-height: 36px;
        padding: 4px 40px 4px 70px;
        clip-path: polygon(0 0, calc(100% - 22px) 0, 100% 100%, 22px 100%);
    }

    .white-parallelogram__text {
        font-size: 1rem;
    }
}

/* ── Responsive: extra-small ── */
@media screen and (max-width: 575.98px) {
    .green-triangle {
        left: 0;
        width: 60px;
        height: 17px;
        clip-path: polygon(0 100%, 50px 0, 100% 100%);
    }

    .blue-parallelogram {
        min-height: 34px;
        padding: 4px 32px 4px 20px;
        clip-path: polygon(0 0, calc(100% - 20px) 0, 100% 100%, 20px 100%);
        margin-left: 40px;
    }

    .blue-parallelogram__text {
        font-size: 0.9rem;
    }

    .tarja-row--bottom {
        margin-left: 0;
        margin-right: 0;
    }

    .white-parallelogram {
        min-height: 30px;
        padding: 4px 34px 4px 56px;
        clip-path: polygon(0 0, calc(100% - 18px) 0, 100% 100%, 18px 100%);
    }

    .white-parallelogram__text {
        font-size: 0.825rem;
    }
}
</style>